export const SET_POLICIES = 'policies/set';
export const ADD_POLICIES_TO_LIST = 'policies/add';
export const EDIT_POLICIES_IN_LIST = 'policies/edit';
export const DELETE_POLICIES_FROM_LIST = 'policies/delete';
export const CLEAR_POLICIES = 'policies/clear';
